module.exports = __webpack_public_path__ + "./docs/img/icon-error_class.59d278bac1a95fc344f456f84c78510f.svg";